import React from 'react';
import { trackEvent, MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { Paths } from './shared/url_helpers';
import I18n from 'i18n-js';

export default function RevertInternationalSettings(props) {
  function trackRevert() {
    trackEvent({
      eventName: MParticleEventName.InternationalSettingsReverted,
      oldShippingRegionCode: props.old_shipping_region_code,
      oldCurrency: props.old_currency,
      newShippingRegionCode: props.shipping_region_code,
      newCurrency: props.currency,
    });
  }

  return (
    <a
      className="color-white"
      rel="nofollow"
      data-method="put"
      href={Paths.revertInternationalSettings.expand({})}
      onClick={trackRevert}
    >
      {I18n.t('discovery.internationalSettingsChanged.cancel')}
    </a>
  );
}
